var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 298,
    viewBox: "0 0 148 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_11141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5344 92.0828C90.754 113.44 95.1066 145.136 95.3044 155.475H94.4051L25.9502 155.6H24.6912C25.0689 148.767 25.6265 148.141 26.0941 137.999L42.1556 138.804C33.5763 137.695 21.5256 131.989 12.7305 124.655C6.30943 119.289 1.59709 113.1 1.21938 107.197C0.89563 102.296 3.21583 98.4506 5.35617 94.0683C8.03609 88.5412 23.594 68.4002 27.3891 65.2879C31.7777 61.7104 46.4183 59.564 46.4183 59.564C47.0119 58.0972 47.3176 56.7736 48.7565 55.8971C48.8464 55.8434 48.9364 55.8077 49.0443 55.7719C55.0157 54.4482 61.2029 54.3588 67.2102 55.5215C67.48 55.593 67.7318 55.7003 67.9656 55.8434C69.3685 56.6126 70.3218 57.9899 70.5376 59.564C70.5376 59.564 79.4048 59.2241 84.7466 62.1218C92.3727 66.6473 99.5491 71.8882 106.168 77.791C106.42 70.6182 106.15 63.4455 105.377 56.3264L114.37 55.6646H114.621C117.877 66.6831 125.053 92.8877 120.827 97.0554C117.643 100.293 90.2503 93.0129 87.5344 92.0828ZM34.3317 91.3494C33.4684 92.2438 32.5331 93.1382 31.7777 94.0683C27.9826 98.1287 24.4394 102.404 21.1659 106.893C17.7665 112.564 42.2456 127.428 48.145 128.841V129.914C48.0191 132.4 47.5515 138.393 45.9327 138.858C47.0119 140.271 54.4581 145.44 57.2999 145.905C61.4547 146.621 66.5627 142.542 69.6563 140.038C73.3614 140.235 76.545 137.391 76.7428 133.706L78.4155 100.221C78.5954 96.5188 75.7356 93.3886 72.0125 93.1918L34.3317 91.3494Z",
    fill: "#47D061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.664 286.624C94.4411 287.053 98.0023 289.146 97.121 293.922V293.886H68.0375C68.8469 289.182 65.3037 287.107 61.5446 286.731C59.6561 286.481 57.7855 286.087 55.9509 285.533V280.524H71.9945C73.4514 280.757 82.8221 285.694 90.664 286.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5446 286.624C65.3037 287.053 68.847 289.128 68.0376 293.779V293.886H26.6697C26.6697 292.634 26.6697 287.804 26.5618 280.471H43.055C44.1521 280.703 49.9436 283.673 56.1128 285.443C57.8935 285.98 59.7101 286.373 61.5446 286.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7535 23.4318C70.7355 23.8432 70.3758 24.1651 69.9442 24.1294C69.6024 24.1115 69.3326 23.8611 69.2607 23.5391C69.2247 23.1277 69.5305 22.7699 69.9442 22.7342C70.3578 22.6984 70.7176 23.0204 70.7535 23.4318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8792 23.6826C60.8972 24.094 60.5914 24.4517 60.1777 24.4875C59.764 24.5054 59.4223 24.2013 59.3863 23.7899C59.3504 23.3964 59.6381 23.0386 60.0338 23.0029H60.0698C60.4835 22.9671 60.8432 23.2712 60.8792 23.6826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6774 83.3897C39.7277 85.876 36.9398 88.5233 34.3318 91.3494C33.4685 92.2438 32.5332 93.1381 31.7778 94.0683C27.9828 98.1287 24.4395 102.404 21.1661 106.893C17.7667 112.564 42.2457 127.428 48.1451 128.841V129.914C48.0192 132.4 47.5516 138.393 45.9329 138.858H45.735C44.5659 138.876 43.3968 138.822 42.2457 138.679C33.6664 137.57 21.6157 131.864 12.8205 124.53C6.39952 119.164 1.68717 112.975 1.30947 107.072C0.985718 102.171 3.30592 98.3254 5.44626 93.9431C8.12618 88.4159 23.6841 68.275 27.4792 65.1626C31.7778 61.7104 46.4185 59.564 46.4185 59.564C47.012 58.0972 47.3178 56.7736 48.7567 55.8971C48.8466 55.8434 48.9365 55.8077 49.0444 55.7719C55.0158 54.4482 61.203 54.3588 67.2103 55.5215C67.4801 55.593 67.7319 55.7003 67.9658 55.8434C69.3687 56.6126 70.3219 57.9899 70.5378 59.564C70.5378 59.564 79.4049 59.2241 84.7467 62.1218C92.3728 66.6473 99.5493 71.8882 106.168 77.791C107.247 78.7211 108.308 79.5797 109.352 80.6171",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6563 140.057C66.5627 142.561 61.4547 146.639 57.2999 145.924C54.4581 145.459 47.0119 140.289 45.9327 138.876C45.8787 138.805 45.8248 138.733 45.7888 138.644",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0941 138C25.6264 148.142 25.0689 148.732 24.6912 155.601H25.9502L94.4051 155.475H95.3044C95.1066 145.137 90.7539 113.441 87.5344 92.0833C86.7071 86.6277 85.9696 81.8518 85.3761 78.2744",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3726 92.0293H87.5344C90.2503 92.9594 117.643 100.239 120.899 97.0198C125.125 92.8521 117.949 66.6116 114.693 55.6289H114.514L105.52 56.2907C106.294 63.4098 106.564 70.5826 106.312 77.7553",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2068 140.057H69.0089C65.7175 140.218 59.836 140.235 58.0734 138.697C56.9942 137.749 56.9403 133.796 58.7389 133.027C59.9799 132.49 62.48 131.65 63.3613 131.131C64.2606 130.702 64.6203 129.628 64.1887 128.734C63.9189 128.197 63.3973 127.822 62.8037 127.75C61.4008 127.625 60.0159 127.625 58.613 127.75C55.9151 128.072 51.6704 130.702 48.1091 129.915",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2673 17.0462C50.4832 15.5437 50.717 13.7729 51.0587 11.9842C51.4724 9.03279 52.6235 6.22451 54.4041 3.82763C58.5229 -0.751483 62.9475 0.965684 66.7066 4.81142C67.7857 5.92043 68.775 7.11887 69.6563 8.38885C72.3542 12.2167 74.4226 16.4381 75.7895 20.9099C77.3723 27.1167 68.5951 41.0508 66.0591 42.0525C65.7533 42.1777 65.4476 42.2671 65.1238 42.3208C61.4187 43.0005 56.7063 39.7093 55.1236 36.4717",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9905 55.6647C48.9905 45.0576 48.4149 35.4522 49.3142 24.8809",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0339 41.9453C65.0699 42.0884 65.1059 42.2315 65.1239 42.3746C66.0412 46.6675 66.293 51.98 67.9837 55.8079",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7422 18.9066C51.3105 18.2448 50.7889 17.6545 50.1954 17.1179C45.9866 13.5405 43.1988 21.5003 44.9434 23.7719C46.0586 24.9167 47.7672 25.2923 49.2601 24.72C49.6018 24.6305 49.9436 24.5053 50.2493 24.3264",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5484 8.44295C70.5556 8.33563 84.5307 5.52735 82.5343 1.64583C81.3832 -0.59006 73.9909 1.77104 66.5986 4.81186C59.5841 7.70958 52.5695 11.2155 50.9508 11.9667L50.699 12.0919",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4908 19.6934C59.998 19.2463 58.3792 19.5325 57.1382 20.4626",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.404 20.3555C48.6306 21.0531 47.6413 21.4466 46.5981 21.4645",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3471 19.9621C70.178 19.4255 67.4801 19.5865 66.9944 20.7492C66.221 22.5379 67.3721 26.5088 67.8758 28.7447C68.1995 30.2651 68.7391 33.2344 66.0771 32.4295",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.354 36.3112C63.5411 37.5812 65.5555 37.6528 66.8325 36.4722C66.9944 36.3291 67.1203 36.1681 67.2462 35.9893",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5015 237.076C55.6813 256.162 55.9151 272.618 55.9871 280.417V285.193",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6233 161.307C37.8391 169.034 32.4613 173.667 25.7885 175.509C23.9719 176.01 22.0834 176.296 20.1948 176.386",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9297 293.886L26.5617 294.083V293.796C26.5617 292.544 26.5617 287.715 26.4538 280.381C26.22 258.129 25.6804 212.875 25.8423 175.473C25.8423 168.497 25.8423 161.789 26.0042 155.564",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5377 170.34C64.5484 192.878 61.167 215.237 55.4295 237.059C51.6344 252.281 47.2279 266.805 42.9832 280.239V280.417C44.0803 280.65 49.8718 283.619 56.041 285.39C57.8756 285.945 59.7462 286.338 61.6347 286.588C65.3938 287.018 68.937 289.093 68.1276 293.743C68.1276 293.779 68.1276 293.797 68.1276 293.833",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4051 155.815C93.29 205.166 82.4264 247.577 72.0304 280.417C73.4873 280.721 82.8221 285.658 90.7 286.588C94.477 287.018 98.0383 289.111 97.157 293.886H67.7498",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6961 280.417H72.0306H56.2568",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9112 280.417H42.8932H26.4719",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5079 293.832H26.418V297.231H67.9298V293.939V293.832H26.5079Z",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0017 293.939V297.231H97.0492V293.939V293.832H68.0377H68.0017V293.939Z",
    stroke: "black",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1736 138.751L26.1121 137.946L18.8098 137.588C15.0866 137.391 12.2269 134.261 12.4067 130.558L12.7125 124.638",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.062 91.332H34.3318L71.9226 93.1207C75.6458 93.3175 78.5055 96.4478 78.3257 100.15L76.7429 133.707C76.5451 137.409 73.3795 140.253 69.6564 140.057H68.5233",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7778 94.0869L69.5485 95.8756C72.858 96.0366 75.394 98.8091 75.2501 102.1L73.7932 131.721L73.4335 138.68",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.233 56.3264C102.085 55.9508 96.8153 48.0805 102.409 44.986C103.128 44.6104 103.902 44.3242 104.693 44.1453C105.215 44.038 105.88 43.8591 106.492 43.7518C107.985 43.5014 109.639 43.5371 110.197 44.9144C110.593 45.612 110.359 46.4885 109.657 46.8999C108.92 47.2398 108.146 47.4902 107.355 47.6512C106.384 47.8658 105.556 48.5992 105.844 48.6529C107.013 48.9748 107.949 49.8513 108.362 50.9782C108.56 51.3717 108.704 51.7831 108.83 52.2124",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.265 44.7533C101.51 42.5532 98.5599 29.6566 101.15 29.0305C103.74 28.4045 104.1 33.6275 105.574 39.7628C105.862 40.9613 106.168 42.2134 106.546 43.4655",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.521 39.8882C105.323 37.5271 109.118 37.2766 109.801 39.0117C110.071 39.6377 110.305 40.2996 110.485 40.9614C111.456 44.2347 111.564 47.9016 110.593 49.7619C110.287 50.5489 109.532 51.0498 108.686 50.9961",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.575 40.9083C110.341 38.422 113.596 37.6886 114.172 39.9245C115.431 44.8256 115.215 48.081 114.37 49.6014C114.226 49.8518 114.046 50.0844 113.83 50.2633C112.913 50.8893 111.636 50.6568 111.006 49.7445",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.514 55.6468C115.035 53.6792 115.035 51.6043 114.514 49.6367",
    stroke: "black",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2595 111.598C31.4539 119.289 44.6557 127.374 48.9543 128.412C48.9543 128.412 48.7205 139.788 46.2205 139.895C39.026 140.181 27.5509 136.157 17.7485 130.021",
    stroke: "white",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4326 280.56C45.9507 281.508 54.2242 285.711 61.4187 286.552C65.1957 286.981 67.9476 288.34 67.8936 294.351",
    stroke: "white",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_11141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 298,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.4967289210d8e12e06673531ec417bdf.svg";
export { ForwardRef as ReactComponent };